import styled from 'styled-components/native';

import { DialogButton } from 'components/Button';

export default styled(DialogButton).attrs({
  labelColor: '#ffffff',
})`
  background-color: ${({ theme }) => theme.button.backgroundColorBlue};
`;
